import classNames from 'classnames';
import styles from '~/components/organisms/instantSearch/instantSearch.module.scss';
import { useSERPActions } from '~/core/state/actions/SERPActionsContext';
import { useShowResults } from '~/hooks/instantSearch/useShowResults';
import { useFullTextResults } from '~/hooks/useFulltextResults';
import { fulltextResultsCount } from '../constants';
import sidebarStyles from '../instantSearchSidebar.module.scss';
import InstantFulltextResult from './InstantFulltextResult';

export const InstantFullText = () => {
    const { showFulltextResults } = useShowResults();
    const { handleGoToResult } = useSERPActions();
    const { fullTextResults } = useFullTextResults();

    const fulltextState = fullTextResults.at(0)?.state;
    const fulltextResult = fullTextResults.at(0)?.result;
    const fulltextTitle = fulltextState?.querySet.name;

    if (!fulltextState || !showFulltextResults || !fulltextResult?.hits || fulltextResult?.hits?.length === 0) {
        return null;
    }

    return (
        <div>
            <div
                role="heading"
                aria-level={2}
                className={classNames(styles.instantResultsTitle, sidebarStyles.instantSidebarTitle)}
                data-testid="instantsearch-sidebar-title"
            >
                {fulltextTitle}
            </div>

            <ul className={sidebarStyles.instantSidebarList}>
                {fulltextResult.hits.slice(0, fulltextResultsCount).map((result, index: number) => (
                    <InstantFulltextResult
                        result={result}
                        order={index + 1}
                        handleGoToResult={handleGoToResult}
                        key={index}
                    />
                ))}
            </ul>
        </div>
    );
};
